import React, { useContext } from 'react'
import { Button } from 'react-bootstrap'
import { RemoveResourcePopupContext, PdfPopupContext } from '../../App'
import Assets from '../../constants/images'
import { FileIconSmall, ImageIcon, PdfIconSmall } from '../../constants/svgs'

const PdfCardSmall = ({ data, setPdfPopupItem, setSelectedResource }) => {
    const [handleRemoveResourcePopup, setHandleRemoveResourcePopup] = useContext(RemoveResourcePopupContext);
    const [handlePdfPopup, setHandlePdfPopup] = useContext(PdfPopupContext);

    return (
        <div className="pdf-card-small border p-2">
            <div className='d-flex '>
                <div className='img-container' onClick={() => {
                    setPdfPopupItem({ file_url: data.file_url })
                    setHandlePdfPopup(true)
                }}
                >
                    <div className='icon-container'>
                        <FileIconSmall />
                    </div>
                </div>

                <div className='w-100 ms-3'>
                    <div className='mb-custom'><ImageIcon /></div>
                    <div className='sub-div d-flex w-100 justify-content-between align-items-center'>
                        <h6
                            className="m-0 p-0"
                            onClick={() => {
                                setPdfPopupItem({ file_url: data.file_url })
                                setHandlePdfPopup(true)
                            }}
                        >
                            {data?.title}
                        </h6>

                        <Button onClick={() => {
                            setHandleRemoveResourcePopup(true)
                            setSelectedResource(data)
                        }} className="btn-remove ms-2">Remove</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PdfCardSmall